import React, { useState } from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { StepButton } from "./stepButton";
import * as Yup from "yup";
import { ModalBody } from "reactstrap";
import Title from "../title";
import { useSelector } from "react-redux";

function MultiStep({ name, handleSubmit, type, scheduleDays, dateIntervals }) {
  const [step, setStep] = useState(1);
  const { gym } = useSelector((state) => state.gym);
  const submit = (values) => {
    console.log("valuesss court", values);
    handleSubmit(values);
  };

  const [dayTimeState, setDayTimeState] = useState({
    Saturday: [],
    Sunday: [],
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
  });

  const formSchema1 = Yup.object().shape({
    name: Yup.string().required("Court name is required"),
  });

  return (
    <>
      <ModalBody>
        <div className="modal-body-content">
          <div className="add-trainer-popup adding-popup bg-white card-panel">
            <div className="basic-info">
              <div className="info-title with-border">
                <Title
                  title={gym.type === "sportClub" ? "Add Court" : " Add Room"}
                  subtitlestyle="ctf-tx-secondary"
                  subtitle={gym.type === "sportClub" ? "Add Info About Court" : "Add Info About Room"}
                />
              </div>
              <Formik
                enableReinitialize
                initialValues={{
                  name,
                  type:gym.type=="sportClub" ? "Tennis" : "Therapy",
                  scheduleDays,
                  dateIntervals,
                  isRestricted:false,
                  isPublished:true,
                  durationsSelected:[]

                }}
                onSubmit={submit}
                validationSchema={formSchema1}
              >
                {({ errors, touched, values, setFieldValue }) => (
                  <Form>
                    <FormFirstStep
                      dayTimeState={dayTimeState}
                      setDayTimeState={setDayTimeState}
                      errors={errors}
                      touched={touched}
                      values={values}
                      setFieldValue={setFieldValue}
                      isCreate={true}
                    />
                    <StepButton step={step} />
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </ModalBody>
    </>
  );
}
MultiStep.defaultProps = {
  name: "",
  type: "Tennis",
  scheduleDays: [],
  dateIntervals: [],
  scheduleDaysByType:{},
  handleSubmit: (values) => {},
};

export default MultiStep;
